<template>
  <v-row style="min-height: 60vh;">
    <v-col>
      <!-- Category selection area -->
      <v-row justify="center">
        <v-col cols="auto" class="btn font-weight-medium text-h5">
          <div :class="'btn-txt ' + ('all' === selected ? 'highlighted' : '')" @click="filtering('all')">
            All Categories
          </div>
        </v-col>
        <v-col cols="auto" class="btn font-weight-medium text-h5">
          <div :class="'btn-txt ' + ('webdev' === selected ? 'highlighted' : '')" @click="filtering('webdev')">
            Web Development
          </div>
        </v-col>
        <v-col cols="auto" class="btn font-weight-medium text-h5">
          <div :class="'btn-txt ' + ('photography' === selected ? 'highlighted' : '')" @click="filtering('photography')">
            Photography
          </div>
        </v-col>
        <v-col cols="auto" class="btn font-weight-medium text-h5">
          <div :class="'btn-txt ' + ('communication' === selected ? 'highlighted' : '')" @click="filtering('communication')">
            Communication
          </div>
        </v-col>
      </v-row>

      <!-- Showcase area -->
      <v-row>
        <v-col cols="12" sm="6" md="4" lg="3" v-for="(item, k) in filteredItems" :key="k">
          <PortfolioCardDetail :data="item" />
        </v-col>
      </v-row>
      <v-row v-if="filteredItems.length === 0" justify="center">
        <v-col cols="12" sm="6" md="4" lg="3">
          No results...
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import articles from '@/assets/articles'

export default {
  data: () => {
    return {
      selected: 'all',
      filteredItems: []
    }
  },

  created() {
    this.filteredItems = [...articles].reverse()
  },

  methods: {
    filtering(e) {
      this.selected = e
      if (e === "all") {
        this.filteredItems = [...articles].reverse()
      } else {
        this.filteredItems = articles.filter(elem => elem.type ===  e).reverse()
      }
    }
  }
}
</script>

<style lang="scss">
.btn {
  text-align: center;
  padding: 10px 20px;
}
.btn-txt {
  cursor: pointer;
  color: #24305e;
}

.highlighted {
  border-bottom: 2px solid black;
}
</style>